// Constants
import { Endpoints } from "~constants/endpoints"

// Utils
import { Api } from "~utils/api"

// Shapes
import { ContactUsPayloadShape } from "~shapes/contact-us"

const CommunicationService = {
  postContactUs: async (payload: ContactUsPayloadShape) => {
    const path = Endpoints.CONTACT_US.URL
    return await Api.post(path, payload)
  },
}

export default CommunicationService
